module.exports = __webpack_public_path__ + "static/media/event.c8c2aa72.svg";